import type { DiagnosisResult, MoneyRecord, SavingGoal } from './models';

export function formatWon(value: number): string {
  return `${Math.max(0, Math.round(value)).toLocaleString('ko-KR')}원`;
}

export function calculateGoalProgress(goal: SavingGoal): number {
  if (goal.targetAmount <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((goal.currentAmount / goal.targetAmount) * 100)));
}

export function calculateRemainingWeeks(goal: SavingGoal): number {
  const remaining = Math.max(0, goal.targetAmount - goal.currentAmount);
  if (remaining === 0) return 0;
  if (goal.weeklySavingAmount <= 0) return 0;
  return Math.ceil(remaining / goal.weeklySavingAmount);
}

export function calculateTargetDate(weeks: number, from = new Date()): string {
  const result = new Date(from);
  result.setDate(result.getDate() + Math.max(0, weeks) * 7);
  return result.toISOString().slice(0, 10);
}

export function formatDateKo(date: string): string {
  const parsed = new Date(`${date}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return date;
  return `${parsed.getFullYear()}. ${String(parsed.getMonth() + 1).padStart(2, '0')}. ${String(parsed.getDate()).padStart(2, '0')}`;
}

export function deriveDiagnosis(answers: number[]): DiagnosisResult {
  const score = answers.reduce((sum, value) => sum + value, 0);
  const average = answers.length ? score / answers.length : 0;
  let type: DiagnosisResult['type'];
  if (average >= 3.4) type = '실천형';
  else if (average >= 2.6) type = '계획형';
  else if (average >= 1.8) type = '관찰형';
  else type = '도전형';
  return { answers, type, score };
}

export function sumByType(records: MoneyRecord[], type: MoneyRecord['type']): number {
  return records.filter((record) => record.type === type).reduce((sum, record) => sum + record.amount, 0);
}

export function applySavingToGoal(goal: SavingGoal, record: MoneyRecord): SavingGoal {
  if (record.type !== 'saving') return goal;
  const currentAmount = Math.min(goal.targetAmount, goal.currentAmount + record.amount);
  return { ...goal, currentAmount, status: currentAmount >= goal.targetAmount ? 'completed' : goal.status };
}
